export const SET_CAMPAIGNS = 'SET_CAMPAIGNS';
export const SET_CAMPAIGNS_ERROR = 'SET_CAMPAIGNS_ERROR';
export const SET_SELECTED_CAMPAIGN = 'SET_SELECTED_CAMPAIGN';
export const SET_SELECTED_CAMPAIGN_ERROR = 'SET_SELECTED_CAMPAIGN_ERROR';
export const SET_MULTIPLE_CAMPAIGNS = 'SET_MULTIPLE_CAMPAIGNS';
export const SET_NO_CAMPAIGNS = 'SET_NO_CAMPAIGNS';
export const SET_INACTIVE_CAMPAIGN = 'SET_INACTIVE_CAMPAIGN';
export const CAMPAIGN_STATS_FETCHING = 'CAMPAIGN_STATS_FETCHING';
export const CAMPAIGN_STATS_FETCH = 'CAMPAIGN_STATS_FETCH';
export const CAMPAIGN_STATS_FETCH_ERROR = 'CAMPAIGN_STATS_FETCH_ERROR';
export const STATS_METRICS_FETCHING = 'STATS_METRICS_FETCHING';
export const STATS_METRICS_FETCH = 'STATS_METRICS_FETCH';
export const STATS_METRICS_FETCH_ERROR = 'STATS_METRICS_FETCH_ERROR';
export const AMBASSADOR_STATS_FETCHING = 'AMBASSADOR_STATS_FETCHING';
export const AMBASSADOR_STATS_FETCH = 'AMBASSADOR_STATS_FETCH';
export const AMBASSADOR_STATS_FETCH_ERROR = 'AMBASSADOR_STATS_FETCH_ERROR';
